import { dateRangePickerIntlIds } from './date-range-picker.ids';

export const dateRangePickerLangEsMx = {
  [dateRangePickerIntlIds.selectPeriodOrDateInput.placeholder]:
    'Seleccione un período o fecha',
  [dateRangePickerIntlIds.goBackToTodayButton.label]: 'Hoy',
  [dateRangePickerIntlIds.clearSelectedPeriodButton.label]:
    'Limpiar la selección',
  [dateRangePickerIntlIds.cancelButton.label]: 'Cancelar',
  [dateRangePickerIntlIds.selectPeriodButton.label]: 'Seleccionar',
  [dateRangePickerIntlIds.previousMonthAria.label]: 'Mes anterior',
  [dateRangePickerIntlIds.nextMonthAria.label]: 'Mes próximo',
};
